var templates = {
	base: require('sma.common/partials/slideout.mustache'),
	block: require('sma.common/partials/slideout_block.mustache')
};

class Slideout {
	get $bottomBarRight() {
		return this.base.find('.sma-slideout-bottom-bar-right');
	}

	get $bottomBarLeft() {
		return this.base.find('.sma-slideout-bottom-bar-right');
	}

	constructor(config) {
		if (config === undefined) {
			config = {};
		}
		this.bodyWidth = config.bodyWidth || 'col-md-7';

		this.base = $(templates.base({
			bodyWidth: this.bodyWidth
		}));

		this.blocking = (config.nonBlocking === undefined)? true : config.nonBlocking;

		if (this.blocking) {
			this.block = $(templates.block());
			this.block.hide();
			$('body').append(this.block);
		}

		if (config.body !== undefined) {
			this.setBody(config.body);
		}

		if (config.buttons !== undefined) {
			this.setBottomBarRight(config.buttons);
		}

		this.base.on('click', '.sma-slideout-close', $.proxy(this.close, this));

		$('body').append(this.base);
	}

	setBody(body) {
		this.base.find('.sma-slideout-body').empty();
		this.base.find('.sma-slideout-body').append(body);
	}

	setTitle(text) {
		this.base.find('.sma-slideout-title-text').html(text);
	}

	setBottomBarRight(content) {
		this.$bottomBarRight.empty();
		this.$bottomBarRight.append(content);
	}

	showBlock() {
		if (!this.blocking) {
			return;
		}

		this.block.fadeIn(300);
		this.block.find('.sma-slideout-block-spinner').fadeIn(300);
	}

	open() {
		if (this.blocking) {
			if (!this.block.is(':visible')) {
				this.showBlock();
				this.block.find('.sma-slideout-block-spinner').hide();
			} else {
				this.block.find('.sma-slideout-block-spinner').fadeOut(300);
			}
		}
		this.base.addClass('sma-slideout-show');

		this.base.trigger('smaslideout:opened', this);
	}

	close() {
		this.base.removeClass('sma-slideout-show');

		if (this.blocking) {
			this.hideBlock();
		}

		this.base.trigger('smaslideout:closed', this);
	}

	hideBlock() {
		this.block.fadeOut(500);
	}
};

module.exports = Slideout;


// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.common/components/slideout.js